import { render, staticRenderFns } from "./TabFinance.vue?vue&type=template&id=19b55737&scoped=true&"
import script from "./TabFinance.vue?vue&type=script&lang=js&"
export * from "./TabFinance.vue?vue&type=script&lang=js&"
import style0 from "./TabFinance.vue?vue&type=style&index=0&id=19b55737&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../nguonhangchina/admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19b55737",
  null
  
)

export default component.exports